module.exports = {"230713002":"团结社区","230713003":"育西社区","230713004":"永胜社区","230713005":"铁南社区","230713006":"宾北社区","230713400":"大青川林场","230713401":"东方红林场","230713402":"秀水林场","230713403":"永翠林场","230713404":"明月林场","230713405":"红光林场","230713406":"秋沙鸭自然保护区","230713407":"北列林场","230713408":"南列林场","230713409":"寒月林场","230713410":"环山林场","230713411":"凉水自然保护区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230713.json
// module id = 752
// module chunks = 0